import React from 'react';
import './Privacy.css'; // Using the same CSS as the Turkish version

const PrivacyEn = () => {
  return (
    <div className="privacy">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="privacy-intro">
          Last Updated: September 10, 2026
        </p>
        
        <div className="privacy-content">
          <section className="privacy-section">
            <p>
              Travel Istanbul ("application") places great importance on the privacy of its users. This privacy policy explains how your personal information is collected, used, shared, and protected. It also specifies the rights you have regarding your personal data and how you can exercise your preferences.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Collection</h2>
            <p>
              Personal data such as name, surname, email address, and location information are collected within the scope of the application. This data is used for subscription management, user account control, and communication purposes related to subscriptions. There is no automatic data collection outside the application or data acquisition from third parties.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Storage</h2>
            <p>
              Among the collected data, name, surname, and email information are securely stored in the database. Location data is used only to improve user experience and is kept locally on the device. Location data is not shared with third parties in any way.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Third Party Sharing</h2>
            <p>
              Your personal data is processed in a limited manner only with service providers involved in user authentication processes. This data is not used for advertising or other commercial purposes and is not shared with any other third parties.
            </p>
          </section>

          <section className="privacy-section">
            <h2>User Rights</h2>
            <p>
              Users can update their name, surname, and email information from within the application, and can also delete their accounts and personal data. You have the right to refuse the processing of your data; however, in this case, only the free features of the application can be used.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Cookies and Tracking Technologies</h2>
            <p>
              The Travel Istanbul application stores some data locally on the device in local databases solely to improve user experience. However, cookies or similar web-based tracking technologies are not used in this application.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Payment Information</h2>
            <p>
              The application provides subscription-based services in a freemium model, with payments processed through Google Play Billing on Android devices and Apple In-App Purchase system on iOS devices. Payment information is securely processed directly by these platforms, and we do not have access to this information.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Security</h2>
            <p>
              Your collected personal data is protected with strong encryption methods, and security measures are taken against unauthorized access.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Retention Period</h2>
            <p>
              Your personal data continues to be stored unless you request deletion.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Contact</h2>
            <p>
              For questions regarding your personal data, you can contact us at <a href="mailto:travelistanbulapp@gmail.com">travelistanbulapp@gmail.com</a>.
            </p>
            <p>
              <strong>Website:</strong> <a href="https://www.travelistanbulapp.com" target="_blank" rel="noopener noreferrer">https://www.travelistanbulapp.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyEn;
